import { Button, ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router';
import { BackIcon } from './SemanticIcons';

const BackButton: React.FC<ButtonProps> = (props) => {
  const navigate = useNavigate();
  return (
    <Button
      startIcon={<BackIcon />}
      color='grayscale'
      size='small'
      onClick={() => navigate(-1)}
      {...props}
      sx={{ width: 'fit-content', ...props.sx }}
    />
  );
};

export default BackButton;
